import _objectSpread from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
var DEFAULT_OPTIONS = {
  buffer: null,
  channelCount: 2,
  channelCountMode: 'clamped-max',
  channelInterpretation: 'speakers',
  disableNormalization: false
};
export var createConvolverNodeConstructor = function createConvolverNodeConstructor(audioNodeConstructor, createConvolverNodeRenderer, createNativeConvolverNode, getNativeContext, isNativeOfflineAudioContext, setAudioNodeTailTime) {
  return /*#__PURE__*/function (_audioNodeConstructor) {
    _inherits(ConvolverNode, _audioNodeConstructor);
    var _super = _createSuper(ConvolverNode);
    function ConvolverNode(context, options) {
      var _this;
      _classCallCheck(this, ConvolverNode);
      var nativeContext = getNativeContext(context);
      var mergedOptions = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);
      var nativeConvolverNode = createNativeConvolverNode(nativeContext, mergedOptions);
      var isOffline = isNativeOfflineAudioContext(nativeContext);
      var convolverNodeRenderer = isOffline ? createConvolverNodeRenderer() : null;
      _this = _super.call(this, context, false, nativeConvolverNode, convolverNodeRenderer);
      _this._isBufferNullified = false;
      _this._nativeConvolverNode = nativeConvolverNode;
      if (mergedOptions.buffer !== null) {
        setAudioNodeTailTime(_assertThisInitialized(_this), mergedOptions.buffer.duration);
      }
      return _this;
    }
    _createClass(ConvolverNode, [{
      key: "buffer",
      get: function get() {
        if (this._isBufferNullified) {
          return null;
        }
        return this._nativeConvolverNode.buffer;
      },
      set: function set(value) {
        this._nativeConvolverNode.buffer = value;
        // Bug #115: Safari does not allow to set the buffer to null.
        if (value === null && this._nativeConvolverNode.buffer !== null) {
          var nativeContext = this._nativeConvolverNode.context;
          this._nativeConvolverNode.buffer = nativeContext.createBuffer(1, 1, nativeContext.sampleRate);
          this._isBufferNullified = true;
          setAudioNodeTailTime(this, 0);
        } else {
          this._isBufferNullified = false;
          setAudioNodeTailTime(this, this._nativeConvolverNode.buffer === null ? 0 : this._nativeConvolverNode.buffer.duration);
        }
      }
    }, {
      key: "normalize",
      get: function get() {
        return this._nativeConvolverNode.normalize;
      },
      set: function set(value) {
        this._nativeConvolverNode.normalize = value;
      }
    }]);
    return ConvolverNode;
  }(audioNodeConstructor);
};